// extracted by mini-css-extract-plugin
export default {"contentWrapper":"authWrapp_contentWrapper__tzCGp","headingWrapper":"authWrapp_headingWrapper__50XbW","logo":"authWrapp_logo__8bARR"};